import * as Primitive from '@/components/ui/popover';
import { cn } from '@/lib/utils';

interface PopoverWrapperProps {
  trigger: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  align?: 'start' | 'center' | 'end';
  container?: Element;
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export function Popover({
  trigger,
  children,
  className,
  align = 'start',
  container,
  isOpen,
  onOpenChange,
}: PopoverWrapperProps) {
  return (
    <Primitive.Popover open={isOpen} onOpenChange={onOpenChange}>
      <Primitive.PopoverTrigger asChild>{trigger}</Primitive.PopoverTrigger>
      <Primitive.PopoverContent
        container={container}
        className={cn('max-h-[400px] w-[250px] overflow-y-auto p-0', className)}
        align={align}
      >
        {children}
      </Primitive.PopoverContent>
    </Primitive.Popover>
  );
}
